import { render, staticRenderFns } from "./EmbedModal.vue?vue&type=template&id=fcbc5914&scoped=true"
import script from "./EmbedModal.vue?vue&type=script&lang=js"
export * from "./EmbedModal.vue?vue&type=script&lang=js"
import style0 from "./EmbedModal.vue?vue&type=style&index=0&id=fcbc5914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbc5914",
  null
  
)

export default component.exports